<template>
    <section class="general-modal">
        <h1>Contact</h1>
        <p>Testachats, <br>rue de Hollande 13,<br> 1060 Bruxelles</p>
        <h2>Service abonnement</h2>
        <p>02 542 33 00 <br>
            de lundi à vendredi de 9h à 12h30 <br>
            de 13h à 17h (sauf le vendredi à 16h)
        </p>
    </section>
</template>

<script>
export default {
    name: "ContactModal"
}
</script>

<style scoped>

</style>
